import { DataVisualizationType } from "components/charting/config/chartTypes";
import { createContext } from "react";

const DataVisualizationTypeContext = createContext<DataVisualizationType>(DataVisualizationType.LINE_CHART);
DataVisualizationTypeContext.displayName = "DataVisualizationTypeContext";

export default DataVisualizationTypeContext;
